import { render, staticRenderFns } from "./IncomingCalls.vue?vue&type=template&id=5716d46c&scoped=true&"
import script from "./IncomingCalls.vue?vue&type=script&lang=js&"
export * from "./IncomingCalls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5716d46c",
  null
  
)

export default component.exports